module.exports = __webpack_public_path__ + "static/media/filter_9_plus_white_18dp.3de41319.svg";